// @flow strict
import * as React from 'react'
import { type ContentfulNode } from '@mondough/contentful'
import {
  getHeroSectionFieldsFromContentful,
  getTextAndImageSectionFieldsFromContentful,
  getTriptychSectionFieldsFromContentful,
  getEmailSignUpFormFieldsFromContentful,
  getMarkdownSectionFieldsFromContentful,
  getCTASectionFieldsFromContentful,
  getSubtitleSectionFieldsFromContentful,
  getBlogRollSectionFieldsFromContentful,
} from './extractContentfulFields'
import { subtitleNodeName } from '@mondough/contentful/src/richTextDecorators'
import { defaultSubtitleSection } from './defaultThemeComponents'
import BusinessHero from '../components/theme-business/BusinessHero'
import BusinessTriptych from '../components/theme-business/BusinessTriptych'
import BusinessVerticalTriptych from '../components/theme-business/BusinessVerticalTriptych'
import BusinessTextAndImage from '../components/theme-business/BusinessTextAndImage'
import BusinessMarkdownSection from '../components/theme-business/BusinessMarkdownSection'
import BusinessCTASection from '../components/theme-business/BusinessCTASection'
import BusinessBlogRollSection from '../components/theme-business/BusinessBlogRollSection'

// When we create the business theme 🔜 the components will go here
// TODO once these are populated, update the business theme contentSectionsRenderer.js

export const businessSubtitleSection = (node: ContentfulNode) => {
  const props = getSubtitleSectionFieldsFromContentful(node)
  // NB: When populating this, do not spread props, pass them in explicitly one by one for bette rreadability
  return <div {...props} />
}
export const businessHeroSection = (node: ContentfulNode) => {
  const {
    title,
    description,
    imageUrls,
    cta,
    flags,
    heroDescription,
  } = getHeroSectionFieldsFromContentful(node)
  return (
    <BusinessHero
      title={title}
      description={description}
      imageUrls={imageUrls}
      cta={cta}
      flags={flags}
      heroDescription={heroDescription}
    />
  )
}
export const businessTextAndImage = (node: ContentfulNode) => {
  const {
    title,
    description,
    imageUrls,
    imageAlts,
    reverse,
    cta,
    flags,
  } = getTextAndImageSectionFieldsFromContentful(node)
  return (
    <BusinessTextAndImage
      title={title}
      description={description}
      imageUrls={imageUrls}
      imageAlts={imageAlts}
      reverse={reverse}
      cta={cta}
      flags={flags}
    >
      {node[subtitleNodeName] && defaultSubtitleSection(node[subtitleNodeName])}
    </BusinessTextAndImage>
  )
}
export const businessTriptych = (node: ContentfulNode) => {
  const {
    sections,
    reverse,
    direction,
    flags,
  } = getTriptychSectionFieldsFromContentful(node)

  if (direction === 'vertical') {
    return (
      <BusinessVerticalTriptych
        sections={sections}
        flags={flags}
        reverse={reverse}
      >
        {node[subtitleNodeName] &&
          defaultSubtitleSection(node[subtitleNodeName])}
      </BusinessVerticalTriptych>
    )
  }

  return (
    <BusinessTriptych sections={sections} reverse={reverse} flags={flags}>
      {node[subtitleNodeName] && defaultSubtitleSection(node[subtitleNodeName])}
    </BusinessTriptych>
  )
}
export const businessEmailSignUpForm = (node: ContentfulNode) => {
  const props = getEmailSignUpFormFieldsFromContentful(node)
  return <div {...props} />
}
export const businessMarkdownSection = (node: ContentfulNode) => {
  const { markdownContent } = getMarkdownSectionFieldsFromContentful(node)
  return (
    <BusinessMarkdownSection markdownContent={markdownContent} reverse={false}>
      {node[subtitleNodeName] && defaultSubtitleSection(node[subtitleNodeName])}
    </BusinessMarkdownSection>
  )
}

export const businessBlogRollSection = (node: ContentfulNode) => {
  const {
    numRows,
    categoryName,
    reverse,
  } = getBlogRollSectionFieldsFromContentful(node)
  return (
    <BusinessBlogRollSection
      numRows={numRows}
      categoryName={categoryName}
      reverse={reverse}
    >
      {node[subtitleNodeName] && defaultSubtitleSection(node[subtitleNodeName])}
    </BusinessBlogRollSection>
  )
}
export const businessCTASection = (node: ContentfulNode) => {
  const {
    ctaType,
    title,
    subtitle,
    reverse,
  } = getCTASectionFieldsFromContentful(node)
  return (
    <BusinessCTASection
      ctaType={ctaType}
      title={title}
      subtitle={subtitle}
      reverse={reverse}
    />
  )
}
